/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "3a7838889f33b9d4f4b1745ccdd3531536552d27";
